/**
 * @summary   Custom footer jQuery.
 *
 * @since     1.0.0
 * @requires  jquery.js
 */


/*--------------------------------------------------------------
# Global declarations
--------------------------------------------------------------*/

// i18n functions
var { __, _x, _n, _nx } = wp.i18n;

/* 
 * Function for conditional string formatting. 
 * Basically a sprintf() for Javascript.
 */
if (!String.prototype.format) {
    String.prototype.format = function() {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function(match, number) { 
            return typeof args[number] != 'undefined'
            ? args[number]
            : match
            ;
        });
    };
}

/*--------------------------------------------------------------
# On document ready
--------------------------------------------------------------*/

(function($) {
    'use strict';


    /*--------------------------------------------------------------
    # JS Debounce Function
    --------------------------------------------------------------*/

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };


    /*--------------------------------------------------------------
    # Header Banner & Countdown Module
    --------------------------------------------------------------*/

    // TODO: make this date dynamic
    var congressStartDate = new Date("2024-09-22T09:30:00Z").getTime();
    var congressEndDate = new Date("2024-09-28T12:00:00Z").getTime();
    var $countdown = $('.lmv-countdown');
    let $headBanner = $( '.js-lmv-site-banner');
    let $siteMain = $( '.site-main' );
    let $headBannerInner = $( '.lmv-site-banner__inner-container');
    let $bannerCloseBtn = $( '.lmv-site-banner__close-btn' ); 
    let storageKey = '_lmv_header_banner';

    // Gets current timestamp
    function getTimestamp() {
        return Math.floor(Date.now() / 1000);
    }

    // Sets local storage item for verifying whether the header banner
    // has been dismissed or not.
    function setShown() {
        try {
            localStorage.setItem(storageKey, getTimestamp());
        } catch (e) {}
    }

    // Retrieves the local storage item that's set only when 
    // a user dismisses the header banner.
    function getShown() {
        try {
            let key = localStorage.getItem(storageKey) * 1;

            console.log(key + 86400)
            console.log(key)
            console.log(Math.floor(Date.now() / 1000 ))

            return ( ( key + 86400 )  > ( Math.floor(Date.now() / 1000 ) ) ) ? key : false;
        } catch (e) {
            return false;
        }
    }

    // Calculates and sets the site's main offset when the header banner with countdown is displayed.
    function setSiteMainOffset() {
        $siteMain.animate({ 'paddingTop': Math.floor( $headBannerInner.outerHeight() ) + 'px' }, 200);
    }

    // Show the countdown and the header banner only if the countdown element exists, 
    // and if the user hadn't dismissed the banner before.
    if ( $countdown.length && ! getShown() ) { 

        let isSetIntervalTriggered = false;

        // Update the count down every 1 second
        const congressTimer = setInterval(function() {

            // Get today's date and time
            var now = new Date().getTime();

            // Find the distance between now and the count down date
            var distance = congressStartDate - now;

            // Find the distance between now and the end of the congress event
            var endDistance = congressEndDate - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            var markup = `
            <a href="https://congress.lausanne.org/" target="_blank" class="lmv-countdown__inner">
                <div class="lmv-countdown__col">
                    <span class="lmv-countdown__number">${days}</span> ${__('days','lmv-theme')}
                </div>
                <div class="lmv-countdown__col">
                    <span class="lmv-countdown__number">${hours}</span> ${__('hours','lmv-theme')}
                </div>
                <div class="lmv-countdown__col">
                    <span class="lmv-countdown__number">${minutes}</span> ${__('minutes','lmv-theme')}
                </div>
                <div class="lmv-countdown__col">
                    <span class="lmv-countdown__number">${seconds}</span> ${__('seconds','lmv-theme')}
                </div>
            </a>
            `;

            // Display the result
            $countdown.html(markup);

            if ( endDistance < 0 ) { // If the event has finished, close the banner all together.
                clearInterval( congressTimer );

                setShown(); // Set cookie for hiding the banner on subsequent loads.
                $siteMain.addClass( 'uk-padding-remove-top' );
                UIkit.alert( '.js-lmv-site-banner' ).close();
            }
            // If the countdown to the congress event is finished, display a message to the users
            // to let them know that the event started.
            else if ( distance < 0) {
                clearInterval( congressTimer );

                $headBanner.addClass( 'lmv-site-banner--congress-live' );

                $( '.lmv-site-banner__p' ).text( __( 'The Fourth Lausanne Congress is now live!', 'lmv-theme' ) );

                var markup = `
                <a href="https://congress.lausanne.org/live/" target="_blank" class="lmv-btn lmv-btn--congress"><span>
                    ${ __( 'Watch now', 'lmv-theme' ) }
                </span></a>
                `;

                $countdown.html(markup);
            }

            if ( ! isSetIntervalTriggered ) { // If the interval is being triggered for the first time.
                isSetIntervalTriggered = true;

                // Display the countdown inside the header banner
                $headBanner.slideDown(200);
                setSiteMainOffset();

                let setOffset = debounce(function() {
                    setSiteMainOffset();
                }, 250);
                
                window.addEventListener('resize', setOffset);
            }

        }, 1000);

        // Reset the main site offset on banner close
        $bannerCloseBtn.click( function() {
            $siteMain.animate({ 'paddingTop': 0 }, 150);
        });
    }

    // Sets a local storage item when a header banner UIKit alert is hidden
    $headBanner.on('hide', function() {
        setShown();
    });

    if ( $headBanner.length && ! getShown() ) { 
        // Display the countdown inside the header banner
        $headBanner.slideDown(200);
        setSiteMainOffset();

        let setOffset = debounce(function() {
            setSiteMainOffset();
        }, 250);

        window.addEventListener('resize', setOffset);
    }

    /*--------------------------------------------------------------
    # LOP single post view - show more authors
    --------------------------------------------------------------*/

    let $lop_show_more_btn = $('.js-lop-more-authors');
    let $lop_secondary_authors_list = $('.lop-authors__secondary-list');
    let $lop_show_more_label = $('.lop-more-authors__show');
    let $lop_show_less_label = $('.lop-more-authors__hide');

    if ( $lop_show_more_btn.length ) {
        $lop_show_more_btn.click( function(e) {
            e.preventDefault();

            $lop_show_more_label.toggle();
            $lop_show_less_label.toggle();

            $lop_secondary_authors_list.toggleClass( 'lop-authors__secondary-list--show' );
        });
    }

    /*--------------------------------------------------------------
    # SOGC sidebar nav and mobile nav
    --------------------------------------------------------------*/

    $( 'li.sogc-menu__item--parent-inner').click( function() {
        $( this )
            .parent( '.uk-nav' )
            .siblings( '.uk-nav' )
            .find( 'li.sogc-menu__item--parent-inner.uk-open' )
            .removeClass( 'uk-open' )
            .find( '.sogc-menu__submenu-children' )
            .slideUp( 219, function() {
                $( this ).css( 'display', 'block' ).attr( 'hidden', true );
            } );
    });


    /*--------------------------------------------------------------
    # Endnotes automation
    --------------------------------------------------------------*/

    // Go through each link and add a ref ID
    $('.entry-content a[href^="#endnote-"]').each(function () {
        var ind = $(this).attr('href').replace('#endnote-', '');
        $(this).attr('id', 'endnote-ref-' + ind);
        UIkit.scroll($(this), {offset: 120});
    });

    // For LOP we look for any <sup> elements
    $('.lop-the-content sup').each( function(i,e){
        var ind = i + 1;
        var $link = $(this).find('a').first();
        $link.attr({id: 'endnote-ref-' + ind, href: '#endnote-' + ind });
        UIkit.scroll($link, {offset: 120});
    });


    // Go through each endnote and add a ref ID and link back to ref note
    $('ol.endnote li, ul.endnote li').each(function (index) {
        $(this).find("a[href^='#']").remove();
        $(this).find(`a[href^='${window.location.href}#']`).remove();
        $(this).attr('id', 'endnote-' + (index + 1));
        $(this).append(` <a href="#endnote-ref-${index + 1}" uk-scroll="offset: 120"><i class="fa-solid fa-arrow-up-long"></i></a>`);
    });


    /*--------------------------------------------------------------
    # Side scrolling for timeline
    --------------------------------------------------------------*/
    const slider = document.querySelector('.timeline__inner');

    if( slider ){
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
    }

    // This fixes the max-height transition issue for these sections
    $('.lmv-expander__inner-content').each(function (index) {
        var scrollHeight = $(this).prop('scrollHeight');
        $(this).css('maxHeight', scrollHeight);
    });


    /*--------------------------------------------------------------
    # Give page scripts
    --------------------------------------------------------------*/

    $('input.amount-other').on('focus', function(){
        $('input#amount-other').prop('checked', true);
    });

    $('input[name=Installment]').on('change', function(){
        if( $(this).val() == '999' ){
            $('#gift-frequency').prop('hidden', false);
        } else {
            $('#gift-frequency').prop('hidden', true); 
        }
    });

    $('input[name=toggler]').on('change', function(){
        if( $(this).val() == '1' ){
            $('#cc-details').prop('hidden', false);
            $('#echeck-details').prop('hidden', true);
            $('#cc-details input, #cc-details select').prop('disabled', false);
            $('#PaymentType').val('CreditCard');
        }
        if( $(this).val() == '2' ){
            $('#cc-details').prop('hidden', true);
            $('#echeck-details').prop('hidden', false);
            $('#echeck-details input, #echeck-details select').prop('disabled', false);
            $('#PaymentType').val('Check');
        }
    });

    

    // Get the 'sku' parameter from the URL to pass to the gift designation on https://lausanne.org/give?sku=
    var urlParams = new URLSearchParams(window.location.search);
    var sku = urlParams.get('sku');

    // Get the select element by its id SKU
    var skuSelect = document.getElementById('SKU');

    // Loop through the options and select the one that matches the 'sku' parameter
    if( skuSelect ){
        for (var i = 0; i < skuSelect.options.length; i++) {
            if (skuSelect.options[i].value === sku) {
                skuSelect.selectedIndex = i;
                break;
            }
        }
    }

    var searchParams = new URLSearchParams(window.location.search)

    if( searchParams.has('gift-frequency') ){
        if( searchParams.get('gift-frequency') == 'monthly'){
            var $radios = $('input:radio[name=Installment]');
            $radios.filter('[value=999]').prop('checked', true);
        }
    }

    if( searchParams.has('amount') ){
        var amount = searchParams.get('amount');
        var $prices = $('input:radio[name=UnitPrice]');
        $prices.filter(`[value=${amount}]`).prop('checked', true);
    }

    if( searchParams.has('period') ){
        var period = searchParams.get('period');
        var $periods = $('input:radio[name=Periodicity]');
        $periods.filter(`[id=${period}]`).prop('checked', true);
    }


    /*--------------------------------------------------------------
    # Lightbox scripts
    --------------------------------------------------------------*/

    // Go through each infographic and make image open in ligthbox
    $('.entry-content figure.report-infographic, .entry-content .report-infographic figure').each(function () {
        
        var $img = $(this).find('img');
        var $caption = $(this).find('figcaption');
        var captionTxt = $(this).find('figcaption').text();
        var largeUri = getHighestResImg($img);     
        var lightbox = `<div uk-lightbox><a
            class="report-infographic-lightbox"
            href="${largeUri}"
            data-alt="${captionTxt}"
            data-caption="${captionTxt}"
        ></a></div>`;
        var downloadLink = `<a 
            class="report-infographic-download" 
            href="${largeUri}" 
            download
        ><i class="fa-solid fa-download"></i> ${__('Download','lmv-theme')}</a>`;

        // Wrap image in lightbox element
        $img.wrap(lightbox);

        // Add "download" link after image
        if( $caption.length ){
            $caption.prepend( downloadLink ); 
        } else {
            $(this).append( downloadLink ); 
        }        
        
    });


    // Helper function to get largest image URL from a srcset attribute
    function getHighestResImg(element) {
        if ( element.attr("srcset") ) {
          return element
            .attr("srcset")
            .split(",")
            .reduce(
              (acc, item) => {
                let [url, width] = item.trim().split(" ");
                width = parseInt(width);
                if (width > acc.width) return { width, url };
                return acc;
              },
              { width: 0, url: "" }
            ).url;
        }
      
        return element.attr("src");
    }


    /*--------------------------------------------------------------
    # Single Global Classrooms
    --------------------------------------------------------------*/
    
    if( $( 'body.single-global-classroom' ).length ) {
        let $lgcVideoOverlay = $( '.js-lgc-single-video-overlay' );
        let $lgcOverlayContent = $( '.lgc-single-video-content' );
        let $lgcVideo = $( '.js-lgc-single-video' );
        let $contentHeader = $( '.content-header' );
        let $ytContainer = $( '.lmv-yt-container' );
        let videoId = youtubeParser( $ytContainer.attr('data-youtube-url') );
        let $episodeOutline = $( '.lgc-episode-outline' );

        function youtubeParser(url){
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            var match = url.match(regExp);
            return (match&&match[7].length==11)? match[7] : false;
        }

        // Modify the YouTube link
        if ( videoId ) {
            let url = "https://www.youtube.com/embed/" + videoId;
            $ytContainer.find( 'iframe' ).attr('src', url);
        }

        $lgcVideoOverlay.click(function() {            
            $lgcVideo.show().fadeTo(300, 1);
            $contentHeader.css( 'padding', 0 ).removeClass('gradient-default').addClass('gradient-default-gray');
            $( this ).hide();
            $lgcOverlayContent.hide();

            $("html, body").animate({
                scrollTop: 0 
            }, "slow"); 

            
            var currentSrc = $('.content-header__video iframe').attr('src');
            // Check if autoplay is already added
            if (!currentSrc.includes('autoplay=1')) {
                $('.content-header__video iframe').attr('src', currentSrc + "?autoplay=1");
            }
            
        });

        $episodeOutline.find( 'a' ).click( function( event ) {
            event.preventDefault();

            let ytVideoId = youtubeParser( $( this ).attr( 'href' ) );
            let ytUrl = "https://www.youtube.com/embed/" + ytVideoId + "?autoplay=1";
            $ytContainer.find( 'iframe' ).attr('src', ytUrl);

            $lgcVideo.show().fadeTo(300, 1);
            $contentHeader.css( 'padding', 0 ).removeClass('gradient-default').addClass('gradient-default-gray');
            $lgcVideoOverlay.hide();
            $lgcOverlayContent.hide();

            $("html, body").animate({
                scrollTop: 0 
            }, 1100); 
        });
    }
    
})( jQuery );